var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _polygon, _path14, _polygon2, _path15, _polygon3, _path16, _path17, _path18, _circle, _path19, _path20, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawCompleteTaskRe44Tb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 747.32007,
    height: 621.03435,
    viewBox: "0 0 747.32007 621.03435",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M904.89,744.88717a50.79382,50.79382,0,0,1-13.58984,12.63c-1.12012.71-2.27,1.38-3.43994,2H860.33044c.32959-.66.64991-1.33.96-2a95.35446,95.35446,0,0,0-19.84034-109.34c16.64014,5.14,32.02,15.16,42.08008,29.37a64.46972,64.46972,0,0,1,10.23,23,96.27569,96.27569,0,0,0-7.66992-48.41c13.50977,10.99,24.03027,26.04,28.04,42.98C918.14,712.06716,915.23035,730.87716,904.89,744.88717Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M339.016,155.95557a3.13178,3.13178,0,0,0,0,6.26355H567.6722a3.13178,3.13178,0,0,0,0-6.26355Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#3ebfbe"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M339.016,174.74619a3.13178,3.13178,0,1,0-.01321,6.26355H483.56161a3.13178,3.13178,0,1,0,0-6.26355Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#3ebfbe"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M339.016,268.95557a3.13178,3.13178,0,0,0,0,6.26355H567.6722a3.13178,3.13178,0,0,0,0-6.26355Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#e4e4e4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M339.016,287.74619a3.13178,3.13178,0,1,0-.01321,6.26355H483.56161a3.13178,3.13178,0,1,0,0-6.26355Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#e4e4e4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M339.016,381.95557a3.13178,3.13178,0,0,0,0,6.26355H567.6722a3.13178,3.13178,0,0,0,0-6.26355Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#e4e4e4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M339.016,400.74619a3.13178,3.13178,0,1,0-.01321,6.26355H483.56161a3.13178,3.13178,0,1,0,0-6.26355Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.11816,178.00023h-.01074a1.82018,1.82018,0,0,1-1.36255-.62549l-9.6997-11.1372a1.82107,1.82107,0,1,1,2.74646-2.39209l8.34253,9.5791,25.04455-28.09717a1.82054,1.82054,0,1,1,2.71838,2.42236l-26.4198,29.64112A1.821,1.821,0,0,1,255.11816,178.00023Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#3ebfbe"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.34,197.48282a29,29,0,0,1,0-58,1,1,0,0,1,0,2,27,27,0,1,0,27.00048,27,1,1,0,0,1,2,0A29.03316,29.03316,0,0,1,255.34,197.48282Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M676.11816,542.51718h-.01074a1.82018,1.82018,0,0,1-1.36255-.62549l-9.6997-11.13721a1.82107,1.82107,0,1,1,2.74646-2.39209l8.34253,9.5791,25.04455-28.09717a1.82054,1.82054,0,1,1,2.71838,2.42237l-26.4198,29.64111A1.821,1.821,0,0,1,676.11816,542.51718Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#3ebfbe"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M676.34,561.99991a29,29,0,0,1,0-58,1,1,0,0,1,0,2,27,27,0,1,0,27,27,1,1,0,0,1,2,0A29.03338,29.03338,0,0,1,676.34,561.99991Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M869.64205,517.58537a10.0558,10.0558,0,0,1,2.75353-15.17148L865.8717,467.2796l17.10819,7.22106,3.57231,32.257a10.11027,10.11027,0,0,1-16.91015,10.82766Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#9e616a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M711.03837,517.58537a10.0558,10.0558,0,0,0-2.75353-15.17148l6.52388-35.13429-17.10819,7.22106-3.57231,32.257a10.11027,10.11027,0,0,0,16.91015,10.82766Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#9e616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "548.355 607.831 536.095 607.831 530.263 560.543 548.357 560.543 548.355 607.831",
    fill: "#9e616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M777.82176,759.19792l-39.53076-.00146v-.5a15.38728,15.38728,0,0,1,15.38647-15.38623h.001l24.144.001Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "599.355 607.831 587.095 607.831 581.263 560.543 599.357 560.543 599.355 607.831",
    fill: "#9e616a"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M828.82176,759.19792l-39.53076-.00146v-.5a15.38728,15.38728,0,0,1,15.38647-15.38623h.001l24.144.001Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "526.418 322.034 510.5 339.568 517.5 470.856 529.5 596.534 551.362 596.534 571.5 372.109 580.465 596.534 603.898 596.534 631.396 332.755 526.418 322.034",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M853.84021,309.01718l-42.5-26.5-6-15H765.60793l-4.26772,14-44,27,17.5,76.5,2,94s68,41,121-5l-21.5-109.5Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#e4e4e4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M730.84021,310.01718l-13.5-1.5s-13.5,10.5-15.5,33.5,0,66.73622,0,66.73622l-8,85.26378,17,1,22-85,2-39.42126Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#e4e4e4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M839.84021,310.01718l13.5-1.5s13.5,10.5,15.5,33.5,10,66.73622,10,66.73622l8,85.26378-17,1-22-85-12-39.42126Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#e4e4e4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 782.14336,
    cy: 224.1156,
    r: 32.80151,
    transform: "translate(-16.01061 663.42875) rotate(-61.33681)",
    fill: "#9e616a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M819.61345,224.748a8.1802,8.1802,0,0,0-1.17452-5.8465,16.54056,16.54056,0,0,0,2.2031-5.61609c.89241-5.96643-3.67747-8.1522-6.62234-12.65813-1.27767-1.955-.699-2.72745-.77132-4.80494a15.06258,15.06258,0,0,0-2.60715-7.83986c-1.81934-3.01593-3.76174-6.16037-6.81342-8.12038-6.41314-4.11892-14.62842-1.38094-21.97727-3.13817-3.23919-.77461-6.263-2.42338-9.49281-3.24939s-7.03294-.61172-8.90461,1.75055c-.86408,1.0906-1.21075,2.51134-2.07735,3.60009-1.72262,2.16377-4.99238,2.525-7.65252,3.60929-5.88256,2.39766-8.91086,8.73973-8.78176,15.00109a24.26955,24.26955,0,0,0,.43287,3.90741,18.16486,18.16486,0,0,0-1.46146,7.55519c.129,6.26135,2.9183,12.44653,6.2533,18.15453a27.24489,27.24489,0,0,1,1.92539-5.17279,3.398,3.398,0,0,1,1.10863-1.45068c1.13286-.72556,2.75-.18237,4.18283-.12532,2.96759.11813,5.32758-1.974,6.72373-4.313s2.16459-5.03414,3.76533-7.24238a4.28194,4.28194,0,0,1,3.0901-2.029,6.45914,6.45914,0,0,1,3.14239.97183c4.83091,2.47559,9.821,5.16487,15.117,5.49842a24.70462,24.70462,0,0,1,5.40455.46126c4.01191,1.15748,6.39447,5.41127,6.91658,9.27825s-.27077,7.67771.04283,11.54617,2.17045,8.20048,6.00537,9.90819a1.767,1.767,0,0,0,1.332.17616,1.52948,1.52948,0,0,0,.66519-.718L816.77,231.4816A19.4283,19.4283,0,0,0,819.61345,224.748Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M973.66,759.51718a1.00276,1.00276,0,0,1-1,1h-381a1,1,0,0,1,0-2h381A1.00275,1.00275,0,0,1,973.66,759.51718Z",
    transform: "translate(-226.33997 -139.48282)",
    fill: "#cacaca"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16004,
    y: 83.81665,
    width: 345.00023,
    height: 2,
    fill: "#e4e4e4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16004,
    y: 195.81665,
    width: 345.00023,
    height: 2,
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16004,
    y: 307.81665,
    width: 345.00023,
    height: 2,
    fill: "#e4e4e4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawCompleteTaskRe44Tb);
export default __webpack_public_path__ + "static/media/undraw_complete_task_re_44tb.c8ce60b6c991cd1c7f397a542be0f1e9.svg";
export { ForwardRef as ReactComponent };